export const venueGetters = {
  venues: (state) => state.venues,
  venueList: (state)=> state.venueList,
  venueDetails: (state)=> state.venueDetails,
  venueDetailsFlag: (state) => state.venueDetailsFlag,
  venueGridLayout: state => state.venueGridLayout,
  selectedVenue: (state) => {
    return state.selectedVenue;
  },
  selectedVenueLoading: (state) => state.selectedVenueLoading,
  venueStartRow: (state) => state.venueStartRow,
}